import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { MemoType } from '@kinderlabs-pos/shared-data-type';

export const modifyMemoAsync = (rootUrl: string) => async (params: MemoType) =>
	(
		await posAxiosClient.put<MemoType>(`${rootUrl}/memo/modify`, {
			params,
		})
	).data;
